import { View, Text, StyleSheet, ImageBackground, Pressable } from 'react-native'
import { createContext, useState } from 'react'
import { Colors } from '../constants/Colors.ts'

export const ThemeContext = createContext({})

export const ThemeProvider = ({ children }) => {
  const [colorScheme, setColorScheme] = useState('dark')
   
  const theme = colorScheme === 'dark'
  ? Colors.dark
    : Colors.light
  
  return (
    <ThemeContext.Provider value={{
      colorScheme, setColorScheme, theme
    }}>
      {children}
    </ThemeContext.Provider>
  )
}